import type {
	MnemonicLikeBatchRequest,
	MnemonicLikeBatchResponse,
	MnemonicLikeRequest,
	MnemonicLikeResponse
} from '../dto/mnemonic-likes';
import { httpArg, httpGet, httpPost, httpRequireAuth, httpRoute, httpUserId } from '../infrastructure/http/http-decorators';

@httpRoute('/api/mnemonic-likes')
@httpRequireAuth()
export abstract class IMnemonicLikeService {
	@httpPost('set')
	setLike(
		@httpArg('request') request: MnemonicLikeRequest,
		@httpUserId() userId?: string
	): Promise<MnemonicLikeResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	@httpGet('batch')
	getLikes(
		@httpArg('request') request: MnemonicLikeBatchRequest,
		@httpUserId() userId?: string
	): Promise<MnemonicLikeBatchResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}
}
